module.exports = __webpack_public_path__ + "media/images/carousel-2-5354092d.jpg";